/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */
import { axiosChatApi } from './setup';

export async function syncConversations () {
  const api = axiosChatApi();
  const response = await api.post('conversations/sync');
  return response && response.data && response.data.conversations ? response.data.conversations : false;
}

export async function createConversation (userHashes, isGroup = false, name) {
  const api = axiosChatApi();
  const response = await api.post('conversation/create', {
    users: _formatUsers(userHashes),
    group: isGroup,
    name
  });
  return response && response.data ? response.data : false;
}

export async function postConversation (conversationType, conversationID, messageType, message) {
  const api = axiosChatApi();
  const response = await api.post(
    'conversation/post',
    {
      type: conversationType,
      recipient: {
        conversationID: conversationID
      },
      message: { type: messageType, value: message }
    }
  );
  return response && response.data ? response.data : false;
}

export async function getConversation (conversationID) {
  const api = axiosChatApi();
  let response = null;
  try {
    response = await api.post(
      'conversation/get',
      {
        conversationID
      }
    );
  } catch (error) {
    return Promise.reject(error);
  }
  return response && response.data ? response.data : false;
}

export async function addParticipants (conversationID, userHashes) {
  const api = axiosChatApi();
  const response = await api.post(
    'conversation/add',
    {
      conversationID, users: _formatUsers(userHashes)
    }
  );
  return response && response.data ? response.data : false;
}

export async function removeParticipants (conversationID, userHashes) {
  const api = axiosChatApi();
  const response = await api.delete(
    'conversation/remove',
    {
      data: {
        conversationID, users: _formatUsers(userHashes)
      }
    }
  );
  return response && response.data ? response.data : false;
}

const _formatUsers = (userHashes) => {
  return userHashes.map((userHash) => ({ userID: userHash }));
};

export async function renameGroup (conversationID, name = null) {
  const api = axiosChatApi();
  const response = await api.put(
    'conversation/rename',
    {
      conversationID, name: name
    }
  );
  return response && response.data ? response.data : false;
}

export async function uploadImage (conversationID, imageFile, progressCallback = () => {}) {
  if (!conversationID) {
    throw new Error({
      type: 'ID_NOT_FOUND'
    });
  }
  if (!imageFile) {
    throw new Error({
      type: 'INVALID_IMAGE'
    });
  }
  let response = null;
  const api = axiosChatApi(true);
  const formData = new FormData();
  formData.append('image', imageFile, imageFile.name);
  formData.append('conversationID', conversationID);
  response = await api.post('conversation/upload',
    formData,
    {
      onUploadProgress: (progressEvent) => {
        if (typeof progressCallback === 'function') {
          progressCallback(parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)));
        }
      }
    }
  );
  return response && response.data ? response.data : false;
}
